import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css' // optional for styling

// @ts-ignore
// tippy('a[href="#tooltip"]', {
//   content(reference) {
//     return reference.getAttribute('title') || '';
//   },
//   allowHTML: true,
//   // content: tooltipContent,
//   trigger: 'click mouseenter',
//   interactive: true,
//   arrow: true,
//   placement: 'left-start',
//   maxWidth: 'none',
// })

const tooltipLinks = document.querySelectorAll<HTMLAnchorElement>(
  'a[href="#tooltip"]'
);

tooltipLinks.forEach((item) => {

  const title = item.getAttribute('title') || '';

  item.removeAttribute('title');
  // @ts-ignore
  tippy(item, {
    content: title,
    allowHTML: true,
    theme: 'content-tooltip',
    // placement: 'right-end',
    arrow: false,
    interactive: true,
  });
})
